var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, CardButtonRH, } from '../../../shared/rewards-hub';
import { getHostURL, getImageURL } from '../../../../utils/GeneralUtil';
import { analyticsStash } from '../../../../utils/analytics';
import { rhAnalytics } from '../../../../constants/RewardsHub';
import { RewardsAndOffersContext } from '../../../../contexts';
var constants = {
    title: "Preferred Pricing",
    headlineEnrolled: "You qualify for exclusive pricing benefits.",
    headlineNotEnrolled: "Ready For More Savings?",
    subtitleEnrolled: "Get lower-than-shelf pricing on thousands of items automatically at checkout.",
    subtitleNotEnrolled: "Once unlocked, you'll get lower-than-shelf pricing on thousands of items automatically at checkout.",
    footerButton: (React.createElement(CardButtonRH, { url: getHostURL("myaccount/proXtraPricing"), label: "Learn More", variant: "secondary", fullWidth: true, callback: function () {
            analyticsStash(rhAnalytics.preferredPricing);
        } })),
    iconUrl: getImageURL("icon-PreferredPricing-NoBoarder.svg"),
    link: getHostURL("myaccount/proXtraPricing"),
};
var PreferredPricingMW = function (props) {
    var isLocked = props.isLocked, enrolled = props.enrolled;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, headline: enrolled
            ? constants.headlineEnrolled
            : constants.headlineNotEnrolled, subtitle: enrolled
            ? constants.subtitleEnrolled
            : constants.subtitleNotEnrolled, footerButton: constants.footerButton });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var PreferredPricingFullWidthDTW = function (props) {
    var isLocked = props.isLocked, enrolled = props.enrolled;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, headline: enrolled
            ? constants.headlineEnrolled
            : constants.headlineNotEnrolled, subtitle: enrolled
            ? constants.subtitleEnrolled
            : constants.subtitleNotEnrolled, footerButton: constants.footerButton });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var PreferredPricingHalfWidthDTW = function (props) {
    var isLocked = props.isLocked, enrolled = props.enrolled;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, headline: enrolled
            ? constants.headlineEnrolled
            : constants.headlineNotEnrolled, subtitle: enrolled
            ? constants.subtitleEnrolled
            : constants.subtitleNotEnrolled, footerButton: constants.footerButton });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var PreferredPricing = function (props) {
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var enrolledInPreferredPricing = ((rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.customerInfo) || {}).enrolledInPreferredPricing;
    var isMobile = props.isMobile, isLocked = props.isLocked, fullWidth = props.fullWidth;
    var data = { isMobile: isMobile, isLocked: isLocked };
    if (isMobile)
        return (React.createElement(PreferredPricingMW, __assign({}, data, { enrolled: enrolledInPreferredPricing })));
    // if (fullWidth) return <BusinessToolsHalfWidthDTW {...data} />;
    // return <BusinessToolsHalfWidthDTW {...data} />;
    // For Demo
    if (fullWidth)
        return (React.createElement(PreferredPricingFullWidthDTW, __assign({}, data, { enrolled: enrolledInPreferredPricing })));
    return (React.createElement(PreferredPricingHalfWidthDTW, __assign({}, data, { enrolled: enrolledInPreferredPricing })));
};
